"use strict";
var assign = require('lodash/assign');
var isEqual = require('lodash/isEqual');
var ResizeDetectorMixin_1 = require('./ResizeDetectorMixin');
var utils_1 = require('./utils');
function default_1(query) {
    var getClasses = utils_1.parseQuery(query);
    var mixin = {
        componentDidResize: function (element) {
            var _a = window.getComputedStyle(element), widthPx = _a.width, heightPx = _a.height;
            var width = utils_1.parsePixels(widthPx);
            var height = utils_1.parsePixels(heightPx);
            var selectorMap = getClasses({ width: width, height: height });
            if (!isEqual(this.$selectorMap, selectorMap)) {
                this.$selectorMap = selectorMap;
                this.setState({ containerQuery: selectorMap });
            }
        },
    };
    return assign(mixin, ResizeDetectorMixin_1.default);
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
//# sourceMappingURL=createContainerQueryMixin.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-container-query/lib/createContainerQueryMixin.js
 ** module id = 422
 ** module chunks = 0
 **/